export const SELECT_TICKET_LOADING = 'SELECT_TICKET_LOADING';
